"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PICKER_COLORS = void 0;
const PICKER_COLORS = ['#F5F7FA', '#B1BACA', '#9099A9', '#59606D', '#34383F', '#000000', '#787C04', '#759825', '#0AA648', '#198E48', '#239393', '#08827A', '#2A7A8D', '#48759C', '#3272D9', '#2C41E3', '#4949DB', '#6767E6', '#7A68B3', '#9656D6', '#BD56D6', '#D656CC', '#D6568C', '#D6246E', '#DE1B1B', '#EA3B12', '#EB6311', '#E68E00', '#D8C430', '#B77100'];
exports.PICKER_COLORS = PICKER_COLORS;
//# sourceMappingURL=constants.js.map